import { t, select } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useUpdateComposerPermissions, useComposersTable } from 'app/domains/templates';
export function UpdateAccessMenuItem(props) {
    const { type, userIds, withSubtitle = false } = props;
    const { drawerData } = useComposersTable();
    const composerIds = (drawerData === null || drawerData === void 0 ? void 0 : drawerData.composerIds) || [];
    const { updateComposerPermissions, loading, refetching } = useUpdateComposerPermissions();
    const handleClick = () => updateComposerPermissions({ type, userIds, composerIds });
    const title = t({
        comment: 'Contract access dropdown option: Title',
        message: select(type, {
            add: 'Grant access',
            remove: 'Remove access',
            other: 'Grant access',
        }),
    });
    const subtitle = t({
        comment: 'Contract access dropdown option: Subtitle',
        message: 'For all users',
    });
    return (<Menu.Item loading={loading || refetching} onClick={handleClick}>
      <Menu.ItemText primary={title} secondary={withSubtitle ? subtitle : undefined}/>
    </Menu.Item>);
}
